
    "use strict";
    var Base = require('@alife/alpha-base/base');
    var cookie = require('@alife/alpha-cookie/cookie');
    var ckInfo = {};

    var CookieInfo = Base.extend({
        attrs: {
            // 是否登录
            isLoggedIn: false,
            // 是否是新用户
            isNewUser: false,
            // 是否第一次登录
            isFirstIn: true,
            // 当前登录用户注册时所在的国家
            country: '',

            firstName: '',
            lastName: '',
            serviceType: '',
            memberSeq: '',

            // 页面显示语言，默认en_US。这个会决定webuser.getLocal().
            locale: '',
            buyerLocale:'',
            buyerSite:'',
            buyerCurrency:''
        },

        setup: function() {
            var usfCookieMap = {};
            if (cookie.get('xman_us_f')) {
                var usfCookieArr = cookie.get('xman_us_f').split('&');
                for (var i = usfCookieArr.length; i--;) {
                    var tempCookieArr = usfCookieArr[i].split('=');
                    usfCookieMap[tempCookieArr[0]] = tempCookieArr[1];
                }
            }
            var isLoginCookie = cookie.get('xman_us_t');
            var userCookie = cookie.get('xman_us_f');
            var userReg = /x_user=([^&"]+)/;

            // 是否登录
            if (isLoginCookie && isLoginCookie.indexOf('sign=y') !== -1) {
                this.set('isLoggedIn', true);
            } else {
                this.set('isLoggedIn', false);
            }

            // 获得用户基本信息，曾经登录过并且在cookie中有用户信息。
            if (userCookie && userReg.test(userCookie)) {
                userCookie.match(userReg);
                userCookie = RegExp.$1;
                userCookie = userCookie.split('|');

                if (userCookie.length >= 5) {
                    this.set('country', userCookie[0]);
                    this.set('firstName', userCookie[1].replace(/</g, "&lt;").replace(/>/g, "&gt;"));
                    this.set('lastName', userCookie[2].replace(/</g, "&lt;").replace(/>/g, "&gt;"));
                    this.set('serviceType', userCookie[3]);
                    this.set('memberSeq', userCookie[4]);
                }
            }
            //前台多语言cookie
            var mlCookieVal = cookie.get('sc_g_cfg_f'),
                mlCookieMap = {};
            if ( typeof(mlCookieVal) == 'string' && mlCookieVal != '' ) {
                var mlCookieArr = mlCookieVal.split('&');
                for ( var i = mlCookieArr.length; i--;) {
                    var itemArr = mlCookieArr[i].split('=');
                    mlCookieMap[itemArr[0]] = itemArr[1];
                }
                this.set('buyerLocale', mlCookieMap['sc_b_locale']);
                this.set('buyerSite', mlCookieMap['sc_b_site']);
                this.set('buyerCurrency', mlCookieMap['sc_b_currency']);

            }


            // 是否是新用户
            if (this.get('memberSeq') !== '') {
                this.set('isNewUser', true);
            }

            // 是否是第一次登录
            if (cookie.get('ali_intl_firstIn') === '') {
                this.set('isFirstIn', true);
            }

            // 获取当前语言。
            if (cookie.get('intl_locale')) {
                this.set('locale', cookie.get('intl_locale'));
            } else {
                // 针对AE国家分站,使用新的key,判断用户是哪个站点
                var xLocale = usfCookieMap['x_locale'];
                if (xLocale) {
                    this.set('locale', xLocale);
                } else {
                    this.set('locale', 'en_US');
                }

            }

            return this;
        }
    });

    ckInfo = new CookieInfo().setup();


    var getIsOversea = function() {
        var isOversea = true;
        var userCookie = cookie.get('xman_us_f');

        // 国内
        if (userCookie && userCookie.indexOf('x_l=1') !== -1) {
            isOversea = false;
        }

        // 国外
        if (userCookie && userCookie.indexOf('x_l=0') !== -1) {
            isOversea = true;
        }

        return isOversea;

    };

    function isNewUser() {
        // 根据memberseq是否存在来判断是否是新用户
        var result = true;
        if (ckInfo.get('memberSeq') !== '') {
            ckInfo.set('isNewUser', false);
            result = false;
        }
        return result;
    }


    module.exports = {
        isLoggedIn: ckInfo.get('isLoggedIn'),
        isNewUser: isNewUser(),
        isFirstIn: ckInfo.get('isFirstIn'),
        country: ckInfo.get('country'),
        firstName: ckInfo.get('firstName'),
        lastName: ckInfo.get('lastName'),
        serviceType: ckInfo.get('serviceType'),
        memberSeq: ckInfo.get('memberSeq'),
        // 服务器地域
        serverDomain: function() {
            var serviceType, hzServiceType;
            ckInfo.setup();
            serviceType = ckInfo.get('serviceType'),
            hzServiceType = ['gs', 'cgs', 'twgs', 'hkgs', 'cnfm'];
            if (hzServiceType.indexOf(serviceType) > -1) {
                return 'hz';
            }
            return 'us';
        },
        getIsLoggedIn: function() {
            ckInfo.setup();

            var isLoggedIn = ckInfo.get('isLoggedIn');

            return isLoggedIn;
        },
        getIsNewUser: function() {
            ckInfo.setup();
            return isNewUser();
        },
        getCountry: function() {
            ckInfo.setup();
            return ckInfo.get('country');
        },
        getFirstName: function() {
            ckInfo.setup();
            return ckInfo.get('firstName');
        },
        getLastName: function() {
            ckInfo.setup();
            return ckInfo.get('lastName');
        },
        getServiceType: function() {
            ckInfo.setup();
            return ckInfo.get('serviceType');
        },
        getMemberSeq: function() {
            ckInfo.setup();
            return ckInfo.get('memberSeq');
        },

        getMemberId:function(){
           var userInfoStr = cookie.get('ali_apache_track');
           var mid = '';
           if(typeof(userInfoStr) === 'string'){
                userInfoStr.match(/mid=([^&"]+)/);
                mid = RegExp.$1;
           }
           return mid;
        },

        getLocale: function() {
            ckInfo.setup();
            return ckInfo.get('locale');
        },

        getBuyerLocale: function() {
            ckInfo.setup();
            return ckInfo.get('buyerLocale');
        },

        getBuyerCurrency: function() {
            ckInfo.setup();
            return ckInfo.get('buyerCurrency');
        },

        getBuyerSite: function() {
            ckInfo.setup();
            return ckInfo.get('buyerSite');
        },

        getIsOversea: getIsOversea


    };
